export const HOST =
  //PROD
  window.location.href.indexOf(`dealerportal.brp-retailenvironment.com`) >= 0 ||
  window.location.href.indexOf(`employeedealerportal.brp-retailenvironment.com`) >= 0 ||
  window.location.href.indexOf(`dsm.brp-retailenvironment.com`) >= 0 ||
  window.location.href.indexOf(`dsc.brp-retailenvironment.com`) >= 0 ||
  window.location.href.indexOf(`merchandisingprogram.brp-retailenvironment.com`) >= 0
    ? `https://api.brp-retailenvironment.com`
    : //TEST
    window.location.href.indexOf(`brp-dealer.acnbinc.com`) >= 0 ||
      window.location.href.indexOf(`brp-employeedealerportal.acnbinc.com`) >= 0 ||
      window.location.href.indexOf(`brp-merchandisingprogram.acnbinc.com`) >= 0 ||
      window.location.href.indexOf(`brp-dsm.acnbinc.com`) >= 0 ||
      window.location.href.indexOf(`brp-dsc.acnbinc.com`) >= 0
    ? `https://brp-om-api.acnbinc.com`
    : //DEV SERVER
    window.location.href.indexOf(`brp-dealer-dev.acnbinc.com`) >= 0 ||
      window.location.href.indexOf(`brp-employeedealerportal-dev.acnbinc.com`) >= 0 ||
      window.location.href.indexOf(`brp-merchandisingprogram-dev.acnbinc.com`) >= 0 ||
      window.location.href.indexOf(`brp-dsm-dev.acnbinc.com`) >= 0 ||
      window.location.href.indexOf(`brp-dsc-dev.acnbinc.com`) >= 0
    ? `https://brp-om-dev-api.acnbinc.com`
    : //DEV LOCAL
    window.location.href.indexOf(`:34732`) > 0 ||
      window.location.href.indexOf(`:3000`) > 0 ||
      window.location.href.indexOf(`:3001`) > 0 ||
      window.location.href.indexOf(`:3002`) > 0 ||
      window.location.href.indexOf(`:3005`) > 0 ||
      window.location.href.indexOf(`:3006`) > 0 ||
      window.location.href.indexOf(`:3007`) > 0
    ? `https://localhost:7173`
    : ``;

export const localeStorageLanguageKey = 'brp_dealer_portal_app_language';
export const localeStorageAccessTokenKey = 'brp_dealer_portal_app_access_token';
export const loginUrl = 'brp_dealer_portal_app_access_token';

// If you need to test/debug SSO, you can put false here and
// it should go with the SSO process with NGROK
export const IsLocalDevOrServerDev =
  HOST.includes('https://localhost:7173') || HOST.includes('https://brp-om-dev-api.acnbinc.com');

// TODO Check for URL with BRP
export const IsProduction = HOST.includes('https://api.brp-retailenvironment.com'); //HOST.includes(`.com`);
export const IsTest = HOST.includes('brp-om-api.acnbinc.com');
export const IsDev =
  window.location.href.indexOf(`:34732`) > 0 ||
  window.location.href.indexOf(`:3000`) > 0 ||
  window.location.href.indexOf(`:3001`) > 0 ||
  window.location.href.indexOf(`:3002`) > 0 ||
  window.location.href.indexOf(`:3005`) > 0 ||
  window.location.href.indexOf(`:3006`) > 0 ||
  window.location.href.indexOf(`:3007`) > 0;

const currentLocationHref = window.location.href.toLowerCase();
const locationContains = value => currentLocationHref.indexOf(value.toLowerCase()) >= 0;

export const IsEmployee =
  locationContains(`employeedealerportal.brp-retailenvironment.com`) ||
  locationContains(`brp-employeedealerportal.acnbinc.com`) ||
  locationContains(`brp-employeedealerportal-dev.acnbinc.com`) ||
  locationContains(`employeedealerportal.`) ||
  locationContains(`:3005`);

export const IsMerchandisingProgram =
  locationContains(`merchandisingprogram.brp-retailenvironment.com`) ||
  locationContains(`brp-merchandisingprogram.acnbinc.com`) ||
  locationContains(`brp-merchandisingprogram-dev.acnbinc.com`) ||
  locationContains(`merchandisingprogram.`) ||
  locationContains(`:3006`);

export const IsDSM =
  locationContains(`dsm.brp-retailenvironment.com`) ||
  locationContains(`brp-dsm.acnbinc.com`) ||
  locationContains(`brp-dsm-dev.acnbinc.com`) ||
  locationContains(`dsm.`) ||
  locationContains(`:3007`);

export const IsImpersonationMode = IsEmployee || IsMerchandisingProgram || IsDSM;

// In local/server dev, bypass SSO challenge for impersonation portals and use regular login flow.
// Set to false only when you explicitly want to test SSO redirect (e.g., via ngrok).
export const BypassImpersonationSsoInDev = true;

export const homePage = '/dealer/home-page';
export const AllowModification = Boolean(true);

export const MapJavascriptApiKey = 'AIzaSyDB2UBWqy9y_udlbFulyd0yRs6kLjT2pmU';

export const MaxAmountOfPeople = 6;
export const UPLOAD_MAX_IMAGE_SIZE = 10000000;
export const UPLOAD_IMAGE_FILE_TYPE = ['image/*'];
export const UPLOAD__FILE_TYPE = [
  ...UPLOAD_IMAGE_FILE_TYPE,
  'application/vnd.ms-excel',
  'text/plain',
  'text/csv',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const PODUrl = IsProduction
  ? 'https://brp.my.salesforce.com/idp/login?app=0sp4R000000XZMs&RelayState=2klHjAqb4HyVTNU6KUJneisiix7buUIcLZ0IOnuSp6LsMRYISon7vaAqogvstcHbOc1SeMewdrFaRA-uerE_kHs9npRUSLfaHLmrA4uhdYQw22KTqhNDmEm0wCxk2L8n5B_G5TN7vN1eX-7TXBwCRLildIr7wisVZy4KiweUFn0v_92pqY09ivfm6caBZJ5FgAVWCMkNm6w3omjv74eXHfXdadZ0Ox60JV9_HvP782L2B1Aw_sxw4rXimD1g63-37k35HvTlmD3HNHGyo5iIjY1FQ3DG6-7OiYhewRVfUmNdFPZBKQ6xKoR1Wpwg1hUUSmthvgIJ0fQLXch1jSou-h57LbLopqm4UXKFx6gMw2s'
  : 'https://brp--nplus1.sandbox.my.salesforce.com/idp/login?app=0sp4R000000XZMs&RelayState=uGvNvdDG6-C-2d1aO8Rv43RLKFxjKqEqaCKq30-GHBB6Lr9SN5JWx5zLADEyusEZVd6mIjYOkZxncd8XyBZ1787uAtlLsgs5YhS1aLovF6s9NuYIAsT4v9xw9usL1IgNZzyWSMA1lMfvcIJ1OTtphzOgIgB6hS_7TXBwCRLildIr7wisVZy4KiweUFn0v_92pqY09ivfm6caBZJ5FgAVWCMkNm6w3omjv74eXHfXdadZ0Ox60JV9_HvP782L2B1Aw_sxw4rXimD1g63-37k35HvTlmD3HNHGyo5iIjY1FQ3DG6-7OiYhewRVfUmNdFPZBKQ6xKoR1Wpwg1hUUSmthvgIJ0fQLXch1jSou-h57LbLopqm4UXKFx6gMw2s';

// Testing override: force external POD URL regardless of environment or impersonation mode.
export const ForceUseExternalPod = false;

export const Version = '0.5.3';
